<template>
    <div class="data resultado"
        :id="'result-' + insurer.name"
        :insurer="'result-' + insurer.name"
        :ref="'result_' + insurer.name">

        <div class="row data grey-top-border with-spacing-top">
            <span class="popup_message" ref="popupMessage"></span>

            <!-- Logo insurer -->
            <div class="col-xs-3 col-sm-2 small-x-padding col-seguradora-order">
                <img class="oferta" src="images/ofertas.png" v-if="showOffer">
                <img
                    class='insurer-badge'
                    :class="{ 'open-insurer': insurerAccess }"
                    :data-seguradora-id="insurer.id"
                    :data-insurer="insurer.name"
                    :data-insurer-id="insurer.id"
                    :data-insurer-badge="insurer.name"
                    :data-tab-id="tabId"
                    :src="(imagesPath || 'images/login-seguradoras') + '/' + insurer.name + '.png'"
                    @click="openInsurer"
                    :title="insurer.nome"/>
                <br/>
                <span style="font-size: 10px;">{{ insurer.nome_abreviado }}</span>
            </div>

            <div v-if="insurer.inativo">
                <div class="col-md-8 inactive with-spacing-top">
                    <div class="alert insurer-inactive"
                    :class="insurer.instabilidade ? 'alert-danger' : 'alert-info'"
                    >{{ insurer.instabilidade ? result.msg_seguradora_fora : result.msg_seguradora_inativa }}
                    </div>
                </div>
            </div>

            <div v-else>
                <!-- Ações e loading da cotação -->
                <div class="col-xs-3 col-sm-2 col-md-1 margin-top-15 small-x-padding">
                    <div class='buttons' v-show="!loadingQuotation" :class="{'has-error': errors.has('preco[comissao[' + insurer.name + ']]')}">
                        <div :style="{width: '76px', margin: '0 auto', visibility: (commissionAccess && showCommission ? 'visible' : 'hidden')}">
                            <div class='input-group input-group-sm'>
                                <input type="text" class="form-control comission" :id="'preco_comissao[' + insurer.name + ']'" :name="'preco[comissao[' + insurer.name + ']]'" v-model="insurer.commission" v-validate="{ rules: { numeric: true, min_value: 1, max_value: 100, required: true} }" data-vv-as="Comissão">
                                <span class="input-group-addon comission">%</span>
                            </div>
                        </div>

                        <button class='btn btn-light btn-xs btn-calculate' title='Calcular' @click.prevent="sendForm($event, insurer)" :disabled="disableButtonQuote">
                            <icon name="calculator"></icon><span> Cotar</span>
                        </button>

                        <div class="error-message" v-if="errors.has('preco[comissao[' + insurer.name + ']]')">{{ errors.first('preco[comissao[' + insurer.name + ']]') }}</div>
                    </div>
                </div>
                <div class="col-xs-4 col-md-4 result-actions with-spacing-top" v-if="loadingQuotation">
                    <img :src="(imagesPath || 'images/status') + '/loading3.gif'" height="60">
                </div>
                <!-- TEMPO -->
                <div class="col-xs-1 col-md-1 hidden-xs hidden-sm small-x-padding col-segundos-order" v-if="showQuotationResult">
                    {{ quotationResult.time }}
                </div>
                <!-- Produto -->
                <div class="col-xs-3 col-md-2 text-left hidden-xs hidden-sm small-x-padding" v-if="showQuotationResult">
                    <div class="product">{{ quotationResult.product }}</div>
                </div>
                <!-- Valores -->
                <div class="col-xs-6 col-sm-4 col-md-2 margin-top-15 text-center small-x-padding col-valores-order" v-if="showQuotationResult">
                    <!-- Valor e parcelamento -->
                    <a class="amazing-tooltip">
                        <div class='in-cash'>{{ numberBrazilianPattern(quotationResult.value, 2) }}</div>
                        <span class='forward hidden-xs hidden-sm'>
                            <div class="payments" v-for="(payments, paymentType) in quotationResult.paymentForms" :key="paymentType">
                                <h5>{{ paymentTypesPreDefinition[paymentType] || paymentType }}</h5>
                                <div v-for="(value, key) in payments" :key="key">
                                    {{ key }} - R$ {{ value }}
                                </div>
                            </div>
                        </span>
                    </a>
                </div>
                <!--Acesso Detalhes da Cotação e BOTÕES DE AÇÕES -->
                <div class='col-xs-10 col-xs-offset-1 col-sm-3 small-x-padding' v-if="showQuotationResult">
                    <div>
                        <button
                            :data-preco-id="quotationResult.priceId"
                            type="button"
                            class="btn btn-primary no-margin open-residence-quotation hidden-xs hidden-sm"
                            :data-tab-id="tabId"
                            :data-insurer="insurer.name"
                            @click="openQuotation"
                            v-if="insurerAccess">
                            <span>
                                <i class="fa fa-sign-in"></i>
                                Abrir na seguradora
                            </span>
                        </button>
                        <button
                            :data-preco-id="quotationResult.priceId"
                            type="button"
                            onclick="location.href=javascript:void(0)"
                            class="btn btn-primary btn-block btn-xs no-margin open-residence-quotation visible-xs-block visible-sm-block"
                            :data-tab-id="tabId"
                            :data-insurer="insurer.name"
                            @click="openQuotation"
                            v-if="insurerAccess">
                            <span>
                                <i class="fa fa-sign-in"></i>
                                Abrir
                            </span>
                        </button>
                    </div>
                    <div>
                        <button
                            type="button"
                            class="btn btn-link no-padding-sides no-margin hidden-xs hidden-sm"
                            data-toggle="modal"
                            @click="showQuotationModalInsurerResult = true">
                            <i class="fa fa-info-circle"></i><span>Detalhes da cotação</span>
                        </button>
                        <button
                            type="button"
                            class="btn btn-link no-padding-sides no-margin visible-xs-block visible-sm-block"
                            data-toggle="modal"
                            @click="showQuotationModalInsurerResult">
                            <i class="fa fa-info-circle"></i> Detalhes
                        </button>
                    </div>
                    <div>
                        <a v-if="isPDFValid()"
                            :id="'pdf-' + quotationResult.priceId"
                            :ref="'pdf-' + quotationResult.priceId"
                            class="btn btn-link no-padding no-margin hidden-xs hidden-sm"
                            :href="quotationResult.pdf"
                            target="_blank">
                            <span>
                                <i class="fa fa-file-pdf-o"></i> PDF da cotação
                            </span>
                        </a>
                    </div>
                </div>
                <!-- Ícone de alerta -->
                <div class='col-xs-8 col-md-8 alert-icon coluna-alert-icon icon-info' v-if="showAlertIcon">
                    <icon name="exclamation-triangle" scale="3"></icon>
                    <button type="button" class="btn btn-primary btn-xs" @click="showQuotationModalAlert = true"><span>DETALHES</span></button>
                </div>
                <div class='col-xs-8 col-md-8 timeout-icon coluna-timeout-icon icon-info' v-if="showTimeoutIcon">
                    <icon name="clock-o" scale="3"></icon>
                    <button type="button" class="btn btn-primary btn-xs" @click="showQuotationTimeoutAlert = true"><span>DETALHES</span></button>
                </div>

                <partial-modal-result-insurer-details
                    v-if="showQuotationResult && showQuotationModalInsurerResult"
                    @close="showQuotationModalInsurerResult = false"
                    :imagesPath="imagesPath"
                    :insurer="insurer"
                    :quotationResult="quotationResult">
                </partial-modal-result-insurer-details>

                <partial-modal-alert-details
                    v-if="showQuotationModalAlert"
                    @close="showQuotationModalAlert = false"
                    :imagesPath="imagesPath"
                    :insurer="insurer"
                    :message="errorTextMessageHover || errorTextMessage">
                </partial-modal-alert-details>

                <partial-modal-timeout-details
                    v-if="showQuotationTimeoutAlert"
                    @close="showQuotationTimeoutAlert = false"
                    :imagesPath="imagesPath"
                    :insurer="insurer"
                    :message="errorTextMessageHover || errorTextMessage">
                </partial-modal-timeout-details>

                <!-- Mensagens de erro -->
                <div class='error col-error' v-if="displayError">
                    <div class="coluna-error-table">
                        <div class='error-message-text' :data-msg-hover="errorTextMessageHover"
                            @mouseenter="showPopupMessage" @mouseleave="hidePopupMessage"
                            v-html="errorTextMessage"></div>
                    </div>
                </div>
            </div>
        </div>

        <div v-if="haveAdditionals" class="row" style="background-color: #f8f8f8;">
            <div class="grey-top-border" style="min-height: 23px; background-color: #f8f8f8;">
                <button class="btn-mostrar-ocultar" @click.prevent="showAndHide" v-show="!showAdditionals">Produtos Adicionais <span><i class="fa fa-caret-down"></i></span></button>
            </div>
            <div ref="produtosAdicionais" style="display: none;">
                <div v-for="additional in additionalProductResult" :key="additional.produto + ' ' + additional.company.id">
                    <partial-insurer-additional-product
                        :additional="additional"
                        :result="result"
                        :insurerAccess="insurerAccess"
                        :pdfs="pdfs">
                    </partial-insurer-additional-product>
                </div>
                <div class="grey-top-border">
                    <button class="btn-mostrar-ocultar" @click.prevent="showAndHide">Ocultar Produtos Adicionais <span><i class="fa fa-caret-up"></i></span></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PartialModalResultInsurerDetails from './PartialModalResultInsurerDetails.vue'
    import PartialModalAlertDetails from './PartialModalAlertDetails.vue'
    import PartialModalTimeoutDetails from './PartialModalTimeoutDetails.vue'
    import PartialInsurerAdditionalProduct from "./PartialInsurerAdditionalProduct.vue"
    import jQuery from 'jquery'
    import axios from 'axios'

    export default {
        props: [
            'insurer',
            'result',
            'showCommission',
            'commissionAccess',
            'insurerAccess',
            'canPrintResults',
            'commission',
            'pdfs',
            "triggerResetAdditionals"
        ],
        components: {
            PartialModalResultInsurerDetails,
            PartialModalAlertDetails,
            PartialModalTimeoutDetails,
            PartialInsurerAdditionalProduct
        },
        data(){
            return {
                isFirefox: typeof InstallTrigger !== 'undefined',
                showQuotationModalInsurerResult: false,
                showQuotationModalAlert: false,
                showQuotationTimeoutAlert: false,
                disableButtonQuote: false,
                loadingQuotation: false,
                timeoutQuotation: null,
                timeoutQuotationDefined: false,
                errorTextMessage: null,
                errorTextMessageHover: '',
                displayError: false,
                showQuotationResult: false,
                showOffer: false,
                showAlertIcon: false,
                showTimeoutIcon: false,
                quotationResult: {
                    time: null,
                    value: null,
                    franchise: null,
                    coverages: null,
                    otherCoverages: null,
                    otherCoveragesHover: '',
                    franchises: null,
                    franchisesHover: null,
                    commission: null,
                    code: null,
                    priceId: null,
                    residence: null,
                    residenceHover: '',
                    product: null,
                    message: null,
                    messageHover: '',
                    adjustments: null,
                    adjustmentsHover: '',
                    paymentForms: {},
                    pdf: "",
                    erropdf: false

                },
                additionalProductsCount: 0,
                additionalProductResult: [],
                haveAdditionals: false,
                showAdditionals: false,
                componentOwnerInsurer: '',
                tabId: null,
                extensionGuid: null,
                extensionVersion: null,
                extensionBackup: null,
                url_extension: null,
            }
        },
        computed: {
            fayeResult(){
                return this.$store.state.faye.result
            },
            paymentTypesPreDefinition(){
                return this.$store.state.Result.paymentTypesPreDefinition
            },
            imagesPath(){
                return this.$root.$options.config.imagesPath
            },
            quotation(){
                return this.$store.getters['quotation']
            },
            lastQuotationSaved(){
                return this.$store.getters['lastQuotationSaved']
            }
        },
        created() {
            this.resultModalId = this.generateGuid();
            this.editionModalId = this.generateGuid();
            this.tabId = this.generateGuid();
            this.url_extension = this.$root.$options.config.environment.applicationUrlApiAutomation + '/api/extension/version/1.0/';
        },
        mounted() {
            this.componentOwnerInsurer = this.insurer.name
            this.$root.$options.eventBus.$on('onInitQuote', insurers => {
                insurers.forEach((insurer) => {
                    this.stepRun({ company: insurer, message: 'Iniciando cálculo...' })
                })
            })
            this.$root.$options.eventBus.$on('setCommissionToAll', (value) => this.setCommissionToAll(value))
            this.setExtensionValues()
        },
        watch: {
            fayeResult(result){
                if(!result) return
                if(result.action == 'STEP')
                    this.stepRun(result.data)
                else if (result.action == 'RESULT')
                    this.eachInsurers(result.data)
            },
            showQuotationResult(value){
                this.$root.$options.eventBus.$emit('invokeResultByInsure', value)
            },
            quotation(quotation){
                if(quotation.results){
                    quotation.results.forEach(element => {
                        this.eachInsurers(element)
                    });
                }
            },
            pdfs(listaPdfs) {
                if (listaPdfs) this.insertPDF(listaPdfs);
            },
            result(value){
            },
            triggerResetAdditionals() {
                this.resetAdditionals()
            }
        },
        methods: {
            generateGuid() {
                return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
                    (
                        c ^
                        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
                    ).toString(16)
                );
            },
            setCommissionToAll(commission){
                this.insurer.commission = commission
            },
            insertPDF(list) {
                let pdf = list.filter(
                value => value.id === this.quotationResult.priceId)
                if (pdf[0]) {
                    this.quotationResult.pdf = pdf[0].company_data ? pdf[0].company_data.pdf: null || pdf[0].pdf
                    if (pdf[0].pdf && pdf[0].pdf.length < 1) {
                        this.quotationResult.erropdf = true;
                    }
                }
            },
            sendForm(e, insurer){
                this.resetAdditionals();
                this.$root.$options.eventBus.$emit('onSavingQuotation')
                this.$root.$options.eventBus.$emit('onValidateEnterpriseForm', insurer)
            },
            stepRun(insurerParams){
                if (this.componentOwnerInsurer != insurerParams.company.name)
                    return

                this.initTimeoutQuotation()

                for(let i = 0; i < this.additionalProductsCount; i++)
                    this.$root.$options.eventBus.$emit('invokeResultByInsure', false)

                this.$store.commit('Result/removeAdditionalProduct', insurerParams.company.name)

                this.additionalProductsCount = 0
                this.showQuotationResult     = false
                this.showAlertIcon           = false
                this.showTimeoutIcon         = false
                this.loadingQuotation        = true
                this.displayError            = true
                this.errorTextMessage        = insurerParams.message.replace(/\n/, '<br>')
            },
            eachInsurers(insurersParams){
                if (this.componentOwnerInsurer != insurersParams.company.name)
                    return
                this.updateInsurer(insurersParams)
            },
            updateInsurer(insurerParams){
                this.disableButtonQuote = false
                this.loadingQuotation   = false
                this.showAlertIcon      = false
                this.showTimeoutIcon    = false

                clearTimeout(this.timeoutQuotation)
                this.timeoutQuotationDefined = false

                if(insurerParams.status === 'additional_product'){
                    this.$store.commit('Result/addAdditionalProduct', insurerParams)
                    this.additionalProductsCount++
                    this.additionalProductResult.push(insurerParams)
                    this.haveAdditionals = true

                    this.$root.$options.eventBus.$emit('invokeResultByInsure', true)
                    return
                }

                if(insurerParams.status !== 'ok'){
                    this.showAlertIcon = true
                    this.showError(insurerParams.messages)

                    this.$nextTick(() => {
                        this.$store.dispatch('onSaveInsurerQuotation', insurerParams)
                    })
                    return
                }

                this.displayError          = false
                this.errorTextMessage      = null
                this.errorTextMessageHover = ''
                this.showQuotationResult   = true

                if(insurerParams.oferta === true)
                    this.showOffer = true

                this.quotationResult.time                = insurerParams.time
                this.quotationResult.value               = insurerParams.premium
                // this.quotationResult.paymentForms        = JSON.parse(insurerParams.valor_parcelado)
                this.quotationResult.paymentForms        = insurerParams.installments
                this.quotationResult.franchise           = insurerParams.franchise
                this.quotationResult.coverages           = insurerParams.company_coverages
                this.quotationResult.otherCoverages      = "" //insurerParams.outras_coberturas
                this.quotationResult.otherCoveragesHover = "" //insurerParams.outras_coberturas_completo_popup
                this.quotationResult.franchises          = insurerParams.company_franchises
                this.quotationResult.franchisesHover     = "" //insurerParams.franquias_popup
                this.quotationResult.code                = insurerParams.company_reference
                this.quotationResult.priceId             = insurerParams.id
                this.quotationResult.residence           = "" //insurerParams.residencia
                this.quotationResult.residenceHover      = "" //this.quotationResult.residence
                this.quotationResult.product             = insurerParams.product
                // this.quotationResult.message             = insurerParams.messages.replace(/\n/, '<br>')
                this.quotationResult.message             = insurerParams.messages
                this.quotationResult.messageHover        = insurerParams.messages
                // this.quotationResult.adjustments         = insurerParams.adjustments.replace(/\n/, '<br>')
                this.quotationResult.adjustments         = insurerParams.adjustments
                this.quotationResult.adjustmentsHover    = insurerParams.adjustments
                this.quotationResult.pdf                 = insurerParams.company_data.pdf || ""

                this.$nextTick(() => {
                    jQuery(this.$refs.insurerElement).find('.dynamic').scroll(() => {
                        jQuery('.dynamic').scrollLeft(jQuery(this.$refs.insurerElement).find('.dynamic').scrollLeft())
                        jQuery('.dynamic-title-bar').css('left', '-' + jQuery(this.$refs.insurerElement).find('.dynamic').scrollLeft() + 'px');
                    })

                    this.$store.dispatch('onSaveInsurerQuotation', insurerParams)
                })
            },
            showError(message ){
                if (message == null)
                    message = ""
                this.displayError          = true
                this.errorTextMessage      = message.toString().replace(/\n/, '<br>')
                this.errorTextMessageHover = ''
                this.showQuotationResult   = false

                if(
                    this.errorTextMessage > 200 ||
                    this.errorTextMessage.split(/<br.?>/).length > 3
                ){
                    this.errorTextMessageHover = this.errorTextMessage
                    this.errorTextMessage      = this.errorTextMessage.split(/<br.?>/, 3).join('<br/>').substr(0, 120).trim() + '...'
                }
            },
            initTimeoutQuotation(){
                if(this.timeoutQuotationDefined)
                    return

                this.timeoutQuotationDefined = true

                this.timeoutQuotation = setTimeout(() => {
                    this.showTimeoutIcon  = true
                    this.loadingQuotation = false
                    this.showError('A seguradora ' + this.insurer.name + ' está demorando mais que o previsto para calcular a cotação!\nEla ainda poderá retornar o resultado, aguarde uns instantes ou tente novamente.')
                }, 120000)
            },
            showPopupMessage(event){
                let target       = jQuery(event.target)
                let messageHover = target.data('msg-hover')

                if(messageHover.length === 0)
                    return

                let popupMessage   = jQuery(this.$refs.popupMessage)
                let posX           = target.offset().left - jQuery('#resultados').offset().left
                let posY           = 0

                popupMessage.html(messageHover)

                let popUpWidth  = popupMessage.width() + (this.isFirefox ? 35 : 0)
                let popUpHeight = popupMessage.height() + (this.isFirefox ? 35 : 0)

                if (target.parent('div.error').length) {
                    popupMessage.css('top', posY - popUpHeight)
                    popupMessage.css('left', posX + ((target.width() / 2) - popUpWidth))
                } else {
                    popupMessage.css('top', posY - popUpHeight)
                    popupMessage.css('left', (posX - popUpWidth))
                }

                popupMessage.show()
            },
            hidePopupMessage(event){
                jQuery(this.$refs.popupMessage).hide()
            },
            isPDFValid() {
            if (this.quotationResult.pdf && this.quotationResult.pdf.length > 1)
                return true
            return false
            },
            numberBrazilianPattern (num, fraction = 2, simple = true) {
                let newNum = Number(num)
                if (simple === true && (isNaN(newNum) || newNum == null || newNum === 'NaN' || newNum === NaN)) {
                    num = num.replace(/\./g, '').replace(',', '.')
                    newNum = Number(num)
                }
                return newNum.toLocaleString('pt-BR', { minimumFractionDigits: fraction, maximumFractionDigits: fraction })
			},
            showAndHide(){
                let hasRenovation = jQuery(this.$refs.produtosAdicionais)

                this.showAdditionals = !this.showAdditionals

                if(this.showAdditionals)
                    hasRenovation.slideDown('slow')
                else
                    hasRenovation.slideUp('slow')
            },
            resetAdditionals() {
                this.additionalProductResult.splice(0, this.additionalProductsCount);
                this.additionalProductsCount = 0;
                this.showAdditionals = false;
                this.haveAdditionals = false;
            },
            setExtensionValues() {
                const guidElement = document.getElementById('extension-guid');
                const versionElement = document.getElementById('extension-version');
                const backupElement = document.getElementById('extension-backup');

                if (guidElement) {
                    this.extensionGuid = guidElement.value;
                }
                if (versionElement) {
                    this.extensionVersion = versionElement.value;
                }
                if (backupElement) {
                    this.extensionBackup = backupElement.value;
                }
            },
            openQuotation(){
                const errorMessage = 'Falha ao abrir cotação na seguradora'

                if(this.extensionGuid === null || this.extensionVersion === null || this.extensionBackup === null){
                    this.setExtensionValues();
                }

                const data = {
                    config: {
                        token: this.$root.$options.config.token,
                        callback: this.$root.$options.config.environment.fayeUrl,
                    },
                    data: {
                        extension_guid: this.extensionGuid,
                        extension_version: this.extensionVersion,
                        connected_backup: this.extensionBackup,
                        insurer: this.insurer.name,
                        result_id: this.quotationResult.priceId
                    }
                }

                try {
                    axios.post(this.url_extension + 'find-quotation', data, {
                        headers: {'Authorization': 'Bearer ' + this.$store.getters['automationBearer'] }
                    }).then(() => {
                        document.getElementById('extension-guid').click();
                    }).catch(error => {
                        console.error(errorMessage, error);
                    });
                } catch (error){
                    console.error(errorMessage, error);
                }
            },
            openInsurer(){
                const errorMessage = 'Falha ao abrir seguradora'

                if(this.extensionGuid === null || this.extensionVersion === null || this.extensionBackup === null){
                    this.setExtensionValues();
                }

                const data = {
                    config: {token: this.$root.$options.config.token},
                    data: {
                        extension_guid: this.extensionGuid,
                        extension_version: this.extensionVersion,
                        connected_backup: this.extensionBackup,
                        insurer: this.insurer.name,
                    }
                }

                try {
                    axios.post(this.url_extension + 'open-insurer', data, {
                        headers: {'Authorization': 'Bearer ' + this.$store.getters['automationBearer'] }
                    }).then(() => {
                        document.getElementById('extension-guid').click();
                    }).catch(error => {
                        console.error(errorMessage, error);
                    });
                } catch (error){
                    console.error(errorMessage, error);
                }
            }
        }
    }
</script>

<style src="residential/sass/result-insurer.scss" lang="sass" scoped></style>



// WEBPACK FOOTER //
// PartialInsurer.vue?7309f4b2